import React, { useEffect, useState } from 'react';
import { loadMapApi, wasPreviouslyLoaded } from './utils';
import { useApi } from '../../hooks';

export interface MapWithScriptProps {
  map: React.ReactElement;
  loading: React.ReactElement;
}

export const MapWithScript = ({ map, loading }: MapWithScriptProps) => {
  const [scriptLoaded, setScriptLoaded] = useState(false);
  const { api } = useApi();

  useEffect(() => {
    let isMounted = true;
    const loadMapsKey = async () => {
      const { googleMapsKey } = (await api.get_api_keys()) || {};

      if (isMounted) {
        if (wasPreviouslyLoaded(googleMapsKey)) {
          setScriptLoaded(true);
          return;
        }
        const scriptTag = loadMapApi(googleMapsKey);
        scriptTag.addEventListener('load', () => {
          setScriptLoaded(true);
        });
      }
    };
    loadMapsKey();
    return () => {
      isMounted = false;
    };
  }, [setScriptLoaded, api]);

  return scriptLoaded ? map : loading;
};
